import React,{PureComponent} from 'react'
import {Switch,Route, Redirect} from 'react-router-dom'

import CustomerList from "@pages/Customer/Index/CustomerIndex";//客户信息
import CompletedCustomer from "@pages/Customer/Index/CustomerCompletedList";//客户信息
import InternalCustomer from "@pages/Customer/Index/CustomerInternalList";//客户信息
import CustomerDetail from "@pages/Customer/CustomerDetail/Detail";
// import FollowPage from "@pages/Customer/Follow/Follow";
import FollowEditInformation from "@pages/Customer/Follow/FollowEditInformation";
import InternalFollowEditInformation from "@pages/Customer/Follow/InternalFollowEditInformation";
import ContractManagement from "@pages/ContractManagement/ContractManagement"; //合同管理
import CustomerInvoice from  "@pages/Customer/CustomerInvoice/CustomerInvoice";
import CustomerFuzzy from  "@pages/Customer/Fuzzy/fuzzy-list/index";
import CustomerFuzzyDetail from  "@pages/Customer/Fuzzy/fuzzy-detail/index";
import CustomerFuzzyTaskDetail from  "@pages/Customer/Fuzzy/fuzzy-detail/task-detail";
import CustomerFuzzyTask from "@pages/Customer/Fuzzy/task-list/index";
import CustomerFuzzyRecommend from "@pages/Customer/Fuzzy/recommend-list/index";
import SMSCode from  "@pages/Customer/SMSCode/List";
import ResearchResults from "@pages/Customer/ResearchResults/List"
import SampleList from  "@pages/Customer/sampleList";//找样列表
import ScoreList from  "@pages/Customer/scoreList";//积分管理
import CouponList from  "@pages/Customer/couponList";// 客户优惠券
class CustomerRouter extends PureComponent{
    render() {
        return (
            <Switch>
                <Route path="/customer/SMSCode" component={SMSCode} />
                <Route path="/customer/list" component={CustomerList} />
                <Route path="/customer/Internal" component={InternalCustomer} />
                <Route path="/customer/completed" component={CompletedCustomer} />
                {/*<Route path="/customer/follow2" component={FollowPage} />*/}
                <Route path="/customer/follow" component={FollowEditInformation} />
                <Route path="/customer/internalFollow" component={InternalFollowEditInformation} />
                <Route path="/customer/invoice" component={CustomerInvoice} />
                <Route path="/customer/contract" component={ContractManagement} />
                <Route path="/customer/detail" component={CustomerDetail} />
                <Route path="/customer/fuzzy-list" component={CustomerFuzzy} />
                <Route path="/customer/fuzzy-recommend" component={CustomerFuzzyRecommend} />
                <Route path="/customer/fuzzy-detail" component={CustomerFuzzyDetail} />
                <Route path="/customer/fuzzy-task-detail" component={CustomerFuzzyTaskDetail} />
                <Route path="/customer/fuzzy-task-list" component={CustomerFuzzyTask} />
                <Route path="/customer/researchResults" component={ResearchResults} />
                <Route path="/customer/sampleList" component={SampleList} />
                <Route path="/customer/scoreList" component={ScoreList} />
                <Route path="/customer/couponList" component={CouponList} />
                <Route path="/*" render={(props) => <Redirect to="/customer/list" />} />
            </Switch>
        );
    }
}
export default CustomerRouter;
